import { ThemeUICSSObject } from 'theme-ui';
import pagination from './pagination';
import { accordion } from './accordion';
import { chat } from './chat';
import { toolbar } from './toolbar';
import autocomplete from './autocomplete';
import { datePicker } from './datePicker';
import { aiMessage } from './aiMessage';
/* IMPORT HERE */
export const components: ThemeUICSSObject = {
  /* PREPEND HERE */
  accordion,
  autocomplete,
  datePicker,
  pagination,
  chat,
  toolbar,
  aiMessage,
};
